import * as PortOne from "@portone/browser-sdk/v2";
import { getPaymentConfiguration } from "@/api/payment/useGetPaymentConfiguration";

interface RequestPaymentProps {
  orderName: string;
  redirectUrl: string;
}

interface UsePortonePaymentReturn {
  requestPayment: (props: RequestPaymentProps) => Promise<string>;
}

function generatePaymentId(): string {
  const timestamp = Date.now().toString(36);
  const randomSuffix = Math.random().toString(36).slice(2, 12);
  return `payment-${timestamp}-${randomSuffix}`;
}

export function usePortonePayment(): UsePortonePaymentReturn {
  const requestPayment = async ({
    orderName,
    redirectUrl,
  }: RequestPaymentProps): Promise<string> => {
    const { storeId, channelKey, itemCode } = await getPaymentConfiguration();

    const paymentId = generatePaymentId();
    const response = await PortOne.requestPayment({
      storeId,
      channelKey,
      paymentId,
      orderName,
      totalAmount: 12000,
      currency: "KRW",
      payMethod: "CARD",
      redirectUrl,
      customer: {
        customerId: `cust-${Date.now()}`,
      },
      bypass: {
        galaxia: {
          ITEM_CODE: itemCode,
        },
      },
    });

    if (response === null) {
      throw new Error("결제가 취소되었습니다.");
    }

    if (response?.code !== undefined) {
      throw new Error(response.message ?? "결제에 실패했습니다.");
    }

    return paymentId;
  };

  return { requestPayment };
}
